"use client";

import { BreadCrumb } from "@/components/templates";
import Image from "next/image";
import styles from "./styles.module.scss";
import { ArrowNavigation, ArrowNavigationRef } from "@/components/atoms";
import { FC, useRef } from "react";
import { realisations } from "./data";
import { useRouter } from "next/navigation";
import classNames from "classnames";

export interface DetailRealisationProps {
  slug: string;
}

export const DetailRealisation: FC<DetailRealisationProps> = ({ slug }) => {
  const router = useRouter();
  const arrowLeftRef = useRef<ArrowNavigationRef>(null);
  const arrowRightRef = useRef<ArrowNavigationRef>(null);

  const currentRealisation = realisations.find((el) => el.slug === slug);
  const indexCurrentRealisation = realisations.findIndex(
    (el) => el.slug === slug
  );

  const nextRealisation =
    indexCurrentRealisation + 1 <= realisations.length - 1 &&
    realisations[indexCurrentRealisation + 1];

  const prevRealisation =
    indexCurrentRealisation >= 0 && realisations[indexCurrentRealisation - 1];

  const handleClickNavigation = (prevOrNext: "prev" | "next") => () => {
    if (prevOrNext === "next") {
      nextRealisation && router.push(`/realisations/${nextRealisation.slug}`);
    } else {
      prevRealisation && router.push(`/realisations/${prevRealisation.slug}`);
    }
  };

  if (!currentRealisation) {
    router.push("/realisations");
  }

  return (
    <>
      <div className={styles.detail_realisation}>
        <div className={styles.left}>
          <BreadCrumb
            className={styles.bread_crumb}
            data={[
              { url: "/", label: "Accueil" },
              { url: "/realisations", label: "Réalisations" },
              {
                url: `/realisations/${slug}`,
                label: currentRealisation?.name || "",
              },
            ]}
          />
          <h1>{currentRealisation?.name}</h1>
          <div
            className={styles.description_container}
            dangerouslySetInnerHTML={{
              __html: currentRealisation?.descriptions || "",
            }}
          />
        </div>
        <div className={styles.right}>
          <Image
            src={currentRealisation?.hero || ""}
            width={3000}
            height={901}
            alt="name"
          />
        </div>
        {!!currentRealisation?.otherImages?.length && (
          <div className={styles.others}>
            {currentRealisation.otherImages.map((el, index) => (
              <div key={index} className={styles.other_image_container}>
                <Image src={el} width={130} height={130} alt="name" />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.navigations}>
        <div className={styles.navigation_container}>
          <div
            className={classNames(styles.prev, {
              "!cursor-not-allowed opacity-50": !prevRealisation,
            })}
            onClick={handleClickNavigation("prev")}
            onMouseOver={() => arrowLeftRef.current?.onMouseOver()}
            onMouseOut={() => arrowLeftRef.current?.onMouseOut()}
          >
            <label>Précédent</label>
            <ArrowNavigation
              ref={arrowLeftRef}
              disabled={!prevRealisation}
              direction="left"
            />
          </div>
          <div
            className={classNames(styles.next, {
              "!cursor-not-allowed opacity-50": !nextRealisation,
            })}
            onClick={handleClickNavigation("next")}
            onMouseOver={() => arrowRightRef.current?.onMouseOver()}
            onMouseOut={() => arrowRightRef.current?.onMouseOut()}
          >
            <label>Suivant</label>
            <ArrowNavigation
              disabled={!nextRealisation}
              ref={arrowRightRef}
              direction="right"
            />
          </div>
        </div>
      </div>
    </>
  );
};
